import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SignatureDebugLogs } from './SignatureDebugLogs';
import { PromptVersionManager } from './PromptVersionManager';
import { ExperimentalTesting } from './ExperimentalTesting';
import { Brain, Database, FlaskConical } from 'lucide-react';

export function AIPromptsManager() {
  return (
    <Tabs defaultValue="extraction-logs" className="space-y-6">
      <div className="rounded-xl border border-border/60 bg-card p-1.5">
        <TabsList className="grid w-full grid-cols-3 h-auto bg-transparent gap-1 p-0">
          <TabsTrigger value="extraction-logs" className="gap-2">
            <Database className="h-4 w-4" />
            <span className="hidden sm:inline">Extraction Logs</span>
            <span className="sm:hidden">Logs</span>
          </TabsTrigger>
          <TabsTrigger value="prompt-versions" className="gap-2">
            <Brain className="h-4 w-4" />
            <span className="hidden sm:inline">Prompt Versions</span>
            <span className="sm:hidden">Prompts</span>
          </TabsTrigger>
          <TabsTrigger value="testing" className="gap-2">
            <FlaskConical className="h-4 w-4" />
            <span className="hidden sm:inline">Testing</span>
            <span className="sm:hidden">Test</span>
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="extraction-logs" className="mt-0">
        <SignatureDebugLogs />
      </TabsContent>

      <TabsContent value="prompt-versions" className="mt-0">
        <PromptVersionManager />
      </TabsContent>

      <TabsContent value="testing" className="mt-0">
        <ExperimentalTesting />
      </TabsContent>
    </Tabs>
  );
}
